module.exports = __webpack_public_path__ + "img/1_wgoods.bbea26a6.jpg";